import { get_reditus_widget_token } from '@apis/reditus'
import { useMemo } from 'react'
import { initReditusWidget, openReditusWidget } from '@services/reditus'
import { useContext } from '@utils/context'

export const useReditusReferral = () => {
  const [rootState] = useContext()
  const currentShop = rootState.AppReducer?.current_shop
  const canLoadWidget = Boolean(currentShop?.shopify_domain)

  const widgetQuery = get_reditus_widget_token({
    enabled: false,
    retry: false,
  })

  const openReferralWidget = async () => {
    let widgetPayload = widgetQuery?.data as A

    if (!widgetPayload && canLoadWidget) {
      const refetchResult = await widgetQuery?.refetch?.()
      widgetPayload = refetchResult?.data as A
    }

    if (!widgetPayload) {
      throw new Error('Unable to load Reditus referral widget token')
    }

    if (!widgetPayload.token || !widgetPayload.productId) {
      const backendError = widgetPayload.error || widgetPayload.message
      throw new Error(
        backendError ||
          'Reditus token endpoint returned invalid data. Please verify backend env vars.',
      )
    }

    // Prevent race conditions from async query onSuccess by explicitly awaiting init here.
    await initReditusWidget(widgetPayload)
    openReditusWidget()
  }

  return useMemo(
    () => ({
      isLoading: Boolean(widgetQuery?.isLoading || widgetQuery?.isFetching),
      error: widgetQuery?.error as Error | undefined,
      isReady: Boolean(widgetQuery?.data) && !widgetQuery?.error,
      termsUrl: (widgetQuery?.data as A)?.termsUrl,
      openReferralWidget,
    }),
    [widgetQuery],
  )
}
